import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { EstadoCuentaClienteParamsEmail, GetEstadoCuentaClienteParams } from "../estado-cuenta-client.interface";
import { EstadoCuentaClienteRepository } from "../Repositories/estado-cuenta-cliente.repository";

@Injectable({
  providedIn: "root",
})
export class EstadoCuentaClientService {
  constructor(
    private fileHandlerService: FileHandlerService,
    private estadoCuentaClienteRepository: EstadoCuentaClienteRepository
  ) {}

  public getEstadoCuentaCliente(estadoCuentaParams: GetEstadoCuentaClienteParams): void {
    this.estadoCuentaClienteRepository
      .getEstadoCuentaCliente(estadoCuentaParams)
      .subscribe(this.fileHandlerService.openPdfInNewTab);
  }

  public sendEmailNotification(request: EstadoCuentaClienteParamsEmail): Observable<ShareMessageResponse> {
    return this.estadoCuentaClienteRepository.sendEmailNotification(request);
  }
}
